import styled, { css } from "styled-components";
import { setFlex, setPosition } from "../variables/utils";
import { BREAKPOINTS, desktop } from "../variables/breakpoints";

const setFontStyle = id => {
  switch (id) {
    case 1:
      return css`
        font-family: outward-block;
        font-size: 20rem;
        line-height: 20rem;
        @media (max-width: ${BREAKPOINTS.xxxl}px) {
          font-size: 17rem;
          line-height: 17rem;
        }
        @media (max-width: ${BREAKPOINTS.xxl}px) {
          font-size: 15rem;
          line-height: 15rem;
        }
        @media (max-width: ${BREAKPOINTS.xlm}px) {
          font-size: 13rem;
          line-height: 13rem;
        }
        @media (max-width: ${BREAKPOINTS.xl}px) {
          font-size: 11.5rem;
          line-height: 11.5rem;
        }
        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 9.5rem;
          line-height: 9.5rem;
        }
      `;
    case 2:
      return css`
        font-family: thunder-blacklc;
        font-size: 20rem;
        line-height: 20rem;
        @media (max-width: ${BREAKPOINTS.xxxl}px) {
          font-size: 17rem;
          line-height: 17rem;
        }
        @media (max-width: ${BREAKPOINTS.xxl}px) {
          font-size: 15rem;
          line-height: 15rem;
        }
        @media (max-width: ${BREAKPOINTS.xlm}px) {
          font-size: 13rem;
          line-height: 13rem;
        }
        @media (max-width: ${BREAKPOINTS.xl}px) {
          font-size: 11.5rem;
          line-height: 11.5rem;
        }
        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 9.5rem;
          line-height: 9.5rem;
        }
      `;
    case 3:
      return css`
        font-family: being-regular;
        font-size: 25rem;
        line-height: 25rem;
      `;
    default:
      return "font-family: outward-block;";
  }
};

export const IndexWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  min-height: 100vh;
  width: 100%;
`;

export const LandingWrapper = styled.div`
  ${setFlex({})};
  ${setPosition({ position: "relative", zIndex: 1 })};
  min-height: 100vh;
  width: 100%;
  padding-bottom: 2.5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding-bottom: 0;
  }
`;

export const LandingContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({})};
  height: 100vh;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    min-height: 100vh;
    height: 100%;
  }
`;

export const NavigationLandingContainer = styled(LandingContainer)`
  ${setPosition({ position: "sticky", zIndex: 5 })};
  ${setFlex({ align: "center" })};
  top: 50%;
  padding-left: 1rem;
  pointer-events: none;
  height: auto;
  ${desktop};
`;

export const LandingColumn = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "column" })};
  width: 50%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }
  ${props =>
    props.$landingVideo &&
    css`
      @media (max-width: ${BREAKPOINTS.sm}px) {
        ${setPosition({ position: "absolute" })};
        width: -webkit-fill-available;
        height: -webkit-fill-available;
        padding: 1rem;
      }
      @media (max-width: ${BREAKPOINTS.xs}px) {
        height: unset;
      }
    `};

  ${props =>
    !props.$landingVideo &&
    css`
      @media (max-width: ${BREAKPOINTS.sm}px) {
        min-height: 115vh;
        pointer-events: none;
      }
    `};
`;

export const LandingVideo = styled.div`
  ${setFlex({})};
  width: 100%;
  height: 100%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }

  video {
    object-fit: cover;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      border: 1px solid transparent;
      border-radius: 15px;
      overflow: hidden;
      width: -webkit-fill-available;
      min-height: 80vh;
    }
  }
`;

export const LandingHeadings = styled.div`
  ${setFlex({ align: "center", justify: "center", direction: "column" })};
  height: 100%;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "flex-end" })};
  }
`;

export const LandingLogoContainer = styled.div`
  ${setFlex({ align: "center", justify: "center" })};
  flex: 1;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    order: 2;
    flex: unset;
    padding-bottom: 1rem;
  }
`;

export const LandingLogo = styled.img`
  height: auto;
`;

export const LandingHeadlineContainer = styled.div`
  ${setFlex({ align: "center" })};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    order: 1;
    padding: 1rem 1.5rem 0 1.5rem;
  }
`;

export const LandingHeadline = styled.h1`
  ${props => setFontStyle(props.$articleId)};
  ${props => props.$fontColor && `color: ${props.$fontColor};`};
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: normal;
  margin: 0;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    white-space: normal;
    font-size: 13rem;
    line-height: 13rem;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    font-size: 12.5rem;
    line-height: 9.5rem;
  }
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    font-size: 12rem;
    line-height: 9rem;
  }
  @media (max-width: ${BREAKPOINTS.xxxs}px) {
    font-size: 10rem;
    line-height: 8rem;
  }
`;

export const LandingSubtitleContainer = styled.div`
  ${setFlex({ justify: "center" })};
  flex: 1;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    order: 3;
    flex: unset;
  }
`;

export const LandingSubtitle = styled.h2`
  ${props => props.$fontColor && `color: ${props.$fontColor};`};
  font-family: akzidenz-grotesk-bold;
  text-transform: uppercase;
  margin: 0;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 1.25rem;
    ${props => props.$mobileFontColor && `color: ${props.$mobileFontColor};`};
  }
`;

export const LandingSubtitleSVG = styled.div`
  ${setFlex({ justify: "center" })};
  color: ${props => props.$secondaryColor};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    color: ${props => props.$primaryColor};
  }
  svg {
    max-width: 70%;
    height: ${props => (props.$subtitle ? "min-content" : "auto")};
    display: block;
    padding-top: 2.5rem;
    @media (max-width: ${BREAKPOINTS.lg}px) {
      padding-top: 0.5rem;
    }
    @media (max-width: ${BREAKPOINTS.sm}px) {
      max-width: 100%;
    }
  }
`;

export const NavigationItem = styled.div`
  ${setPosition({ position: "absolute" })};
  cursor: pointer;
  transform: translate(
    ${props => props.$x || 0}px,
    ${props => props.$y || 0}px
  );
  z-index: ${props => props.$z || 0};
  transition: transform 0.3s ease, z-index 0.3s ease;
  ${props => !props.$isActive && "filter: blur(2px);"};
`;

export const NavigationImage = styled.img`
  ${props => `aspect-ratio: ${props.$aspectRatio}`};
  width: auto;
  max-width: 100%;
  @media (max-width: ${BREAKPOINTS.xxxxl}px) {
    max-width: 50%;
  }
`;
